import type React from "react";
import type { LabelProps } from "../../Forms/NewLabelWrapper";
import {
  SelectComboField,
  type SelectComboFieldProps,
} from "../../Forms/SelectCombo/SelectCombo";
import {
  getUnitsOptionsForParameter,
  isConvertibleParameter,
} from "../parameterUnits";

export interface ParameterUnitsSelectProps
  extends Omit<SelectComboFieldProps, "options"> {
  parameter: string | null;
  label?: LabelProps;
}

/**
 * A dropdown component for selecting units based on the selected parameter.
 * Energy parameters allow selection between kWh, Wh, and MWh.
 * Volume parameters allow selection between m3 and litres.
 * Other parameters show a disabled dropdown with their base unit.
 */
function ParameterUnitsSelect(
  props: ParameterUnitsSelectProps,
): React.ReactElement {
  const { parameter, disabled, ...rest } = props;

  const options = parameter ? getUnitsOptionsForParameter(parameter) : [];
  const isConvertible = parameter ? isConvertibleParameter(parameter) : false;

  // Disable the dropdown if the parameter is not convertible or if disabled prop is true
  const isDisabled = disabled || !isConvertible;

  return (
    <SelectComboField
      {...rest}
      options={options}
      disabled={isDisabled}
      clearable={false}
    />
  );
}

export default ParameterUnitsSelect;
